export default __webpack_public_path__ + "942d44c20c6805eb85a8c1fc721d1bbf.png";